import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { Placeholder } from "react-bootstrap";
import { getUserApi } from '../../../services/UserService';
import { getLabelByValue, roleOptionsList } from "../../../utils";
import { connect } from 'react-redux';
import './User.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PermissionsPopup from './PermissionPopup';
import ChangePassword from './ChangePassword';

const UserDetailsLoading = () => {
    return (
        <div>
            <div className="card">
                <div className="card-body">
                    <div className="w-100 px-2 mt-3">
                        <Placeholder animation="glow">
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                            <Placeholder
                                xs={12}
                                style={{ height: "20px" }}
                                className="rounded my-2"
                            />
                        </Placeholder>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <div className="d-flex align-item-center justify-content-between">
                        <div className="w-100 px-2">
                            <Placeholder animation="glow">
                                <Placeholder
                                    xs={12}
                                    style={{ height: "20px" }}
                                    className="rounded my-2"
                                />
                                <Placeholder
                                    xs={12}
                                    style={{ height: "20px" }}
                                    className="rounded my-2"
                                />
                            </Placeholder>
                        </div>

                        <div className="w-100 px-2">
                            <Placeholder animation="glow">
                                <Placeholder
                                    xs={12}
                                    style={{ height: "20px" }}
                                    className="rounded my-2"
                                />
                                <Placeholder
                                    xs={12}
                                    style={{ height: "20px" }}
                                    className="rounded my-2"
                                />
                            </Placeholder>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const UserDetails = ({ userRole }) => {
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [user, setUser] = useState(null);
    const navigate = useNavigate();
    const countPermissions = (permissions) => {
        if (permissions.allSelected) {
            return 4;
        }
        return Object.values(permissions).filter(value => value === true).length;
    };

    useEffect(() => {
        const fetchUser = async () => {
            setIsLoading(true);
            try {
                const response = await getUserApi(id);
                setUser(response.data.results);
            } catch (error) {
                toast.error('Error fetching user:', error);
            }
            setIsLoading(false);
        };

        fetchUser();
    }, [id]);

    const generateAvatar = (firstName, lastName) => {
        const initials = `${firstName[0] || ''}${lastName[0] || ''}`.toUpperCase();
        return <div className="avatarr">{initials}</div>;
    };

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-4">
                        {isLoading ? (
                            <UserDetailsLoading />
                        ) : user !== null ? (
                            <div>
                                <div className="card">
                                    <div className="card-header">
                                        <div className="d-flex align-items-center justify-content-between w-100">
                                            <div className="d-flex align-items-center">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary btn-sm btn-circle"
                                                    onClick={() => navigate("/user")}
                                                >
                                                    <i className="fa-solid fa-arrow-left"></i>
                                                </button>
                                                <h4 className="mb-0 ms-2">User Details</h4>
                                            </div>
                                            <div>
                                                {userRole === "SuperAdmin" && (
                                                    <button
                                                        className="btn btn-outline-primary btn-sm ms-1"
                                                        onClick={() =>
                                                            navigate(`/edit-user/${user.id}`, {
                                                                state: { user: user },
                                                            })
                                                        }
                                                    >
                                                        <i className="fa-solid fa-pen-to-square"></i> Edit
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">

                                        <div className="profile-photo-section d-flex align-items-center px-3">
                                            {user.profile_photo ? (
                                                <img
                                                    src={user.profile_photo}
                                                    alt="Profile"
                                                    className="profile-photo"
                                                />
                                            ) : (
                                                generateAvatar(user.first_name, user.last_name)
                                            )}
                                            <div className="user-info ms-1">
                                                <h3>{user.first_name} {user.last_name}</h3>
                                                <ul>
                                                    <li className="my-3">
                                                        <span className="fw-normal">Email:</span>
                                                        <span className="fw-bold ms-2">{user.email}</span>
                                                    </li>
                                                    <li className="my-3"> <span className="fw-normal">Phone:</span>
                                                        <span className="fw-bold ms-2">{user.phone_number}</span></li>
                                                    <li className="my-3"></li>
                                                </ul>

                                            </div>
                                        </div>
                                        <hr />
                                        <ul className="px-3">
                                             {/* Status */}
                                             <li className="my-2">
                                                <span className="fw-bold text-black">Status:</span>
                                                <span
                                                    className={`badge light border-0 badge-sm ms-2 ${user.status.toLowerCase() === "active"
                                                        ? "badge-success"
                                                        : "badge-danger"
                                                        }`}
                                                >
                                                    {user.status}
                                                </span>
                                            </li>
                                            
                                            {/* Role */}
                                            <li className="my-2">
                                                <span className="fw-bold text-black">Role:</span>
                                                <span className="badge light border-0 badge-info badge-sm ms-2">
                                                    {getLabelByValue(user.role, roleOptionsList)}
                                                </span>
                                            </li>
                                        </ul>
                                        <ul className="d-flex align-items-center justify-content-between px-3">
                                            {/* Division (conditionally rendered) */}
                                            {user.role.toLowerCase() === "auditor" &&
                                                user.auditor_profile?.assigned_divisions?.length > 0 && (
                                                    <li className="my-1 ">
                                                        <span className="fw-bold text-black">Division: </span>
                                                        {user.auditor_profile.assigned_divisions
                                                            .map((division) => <span className='badge bg-secondary badge-sm mx-2 mb-2'>{division.name} </span>)}
                                                    </li>
                                                )}
                                        </ul>

                                        <hr />
                                        <div className="permissions-section">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h4 className="mb-0">Permissions</h4>
                                                <PermissionsPopup
                                                    permissionsData={{
                                                        'Document Permission': user.document_permission,
                                                        'Audit Permission': user.audit_permission,
                                                        'Test/Evaluation Permission': user.test_evaluation_permission,
                                                    }}
                                                />
                                            </div>
                                            <ul className="list-group mt-3">
                                                <li className="list-group-item d-flex justify-content-between align-items-center">
                                                    <span className="text-black">Audit Permission:</span>
                                                    <span>{countPermissions(user.audit_permission)}</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between align-items-center">
                                                    <span className="text-black">Test/Evaluation Permission:</span>
                                                    <span>{countPermissions(user.test_evaluation_permission)}</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between align-items-center">
                                                    <span className="text-black">Document Permission:</span>
                                                    <span>{countPermissions(user.document_permission)}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-body text-center">
                                        <div className="action-group d-flex align-items-center justify-content-between">
                                            <span className='text-black'>Change Password?</span>
                                            <ChangePassword id={user?.id} />
                                        </div>
                                        {/* <hr /> */}
                                        {/* <div className="action-group d-flex align-items-center justify-content-between mt-3">
                                            <span className='text-black'>Deactivate User</span>
                                            <button className="btn btn-sm btn-danger">Deactivate</button>
                                        </div> */}
                                    </div>
                                </div>

                            </div>
                        ) : (
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="text-center text-danger">
                                        ⚠️ User Not Found!
                                        <br /> ID {id}
                                    </h4>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="col-md-8">
                        <div className="card p-4 shadow-sm">

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    userRole: state.auth.user?.role || "User",
});
export default connect(mapStateToProps)(UserDetails);


